import { vehicleCategoriesSlice } from "./vehicleCategoriesSlice";
import * as defaultActions from "../../../../../redux/_common";

const { actions } = vehicleCategoriesSlice;
export const moduleUrl = "/api/appmasterdata/vehicleCategories";

export const setValidationErrors = actions.setValidationErrors;

export const getVehicleCategories = (params: {}) => defaultActions.getItems(moduleUrl, actions, params);
export const getVehicleCategory = (id: string) => defaultActions.getItem(`${moduleUrl}/${id}`, actions);
export const saveVehicleCategory = (item: {}, id: string | null) => defaultActions.saveItem(moduleUrl, actions, item, id);
export const deleteVehicleCategory = (id: string) => defaultActions.deleteItem(`${moduleUrl}/${id}`, actions);
export const getDropDownItems = (params: {}) => defaultActions.getDropDownItems(`${moduleUrl}/select`, actions, params);

export const clearAll = () => defaultActions.clearAll(actions);
export const clearVehicleCategory = () => defaultActions.clearItem(actions);
export const clearErrors = () => defaultActions.clearErrors(actions);

export const getFilters = () => defaultActions.getFilters(moduleUrl, actions);
export const setFilter = (filters: any) => defaultActions.setFilters(filters, actions);
